import React from 'react';
import { Alert, Snackbar } from '@mui/material';
import WifiOffIcon from '@mui/icons-material/WifiOff';
import { useSelector } from 'react-redux';

const OfflineBanner = () => {
  const isOnline = useSelector((state) => state.pwa.isOnline);

  return (
    <Snackbar
      open={!isOnline}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
      sx={{ bottom: { xs: 70, sm: 24 } }}
    >
      <Alert
        severity="warning"
        icon={<WifiOffIcon />}
        sx={{
          width: '100%',
          backgroundColor: '#ff9800',
          color: '#fff',
          '& .MuiAlert-icon': {
            color: '#fff'
          }
        }}
      >
        You're offline. Some features may not be available.
      </Alert>
    </Snackbar>
  );
};

export default OfflineBanner;